import { useState, useEffect } from "react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const ok = localStorage.getItem("verlo_cookie_ok");
    if (!ok) setShow(true);
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[70] bg-verlo text-paper px-5 py-4 rounded-lg flex items-center justify-between gap-4"
    >
      <p className="text-sm text-paper/90">
        We use a few essential cookies to make this site work.
      </p>
      <button
        data-testid="cookie-dismiss"
        onClick={() => {
          localStorage.setItem("verlo_cookie_ok", "1");
          setShow(false);
        }}
        className="text-sm font-medium text-brass hover:text-paper transition-colors whitespace-nowrap"
      >
        Okay
      </button>
    </div>
  );
}
